import store from "../store";
import axios from "axios";
const RESOURCE_NAME = process.env.VUE_APP_IMJ_API_URL;

export default {
  getAll() {
    return axios.get(RESOURCE_NAME);
  },
  getFreeQuestion(data) {
    return axios.get(`${RESOURCE_NAME}/index.php?r=public%2Fquestion`, {
      params: data,
    });
  },
  postCheckFree(data) {
    return axios.post(`${RESOURCE_NAME}/index.php?r=public/check`, data);
  },
  getAnswerFree(data) {
    return axios.post(`${RESOURCE_NAME}/index.php?r=public/get-answer`, data);
  },
  getExpectFree(data) {
    return axios.post(
      `${RESOURCE_NAME}/index.php?r=public/get-explanation`,
      data
    );
  },
  createRegister(data) {
    return axios.post(`${RESOURCE_NAME}/index.php?r=public/register`, data);
  },
  resetByPhone(data) {
    return axios.post(
      `${RESOURCE_NAME}/index.php?r=public/reset-by-phone`,
      data
    );
  },
  resetByPhoneVerify(data) {
    return axios.post(
      `${RESOURCE_NAME}/index.php?r=public/reset-by-phone-verify`,
      data
    );
  },
  login(data) {
    return axios.get(`${RESOURCE_NAME}/index.php?r=private/test`, data);
  },
  getProfile() {
    return axios.get(`${RESOURCE_NAME}/index.php?r=private/profile`, {
      auth: {
        username: store.state.username,
        password: store.state.password,
      },
    });
  },

  getTeacherProfile() {
    return {
      data: {
        type: "teacher",
        teacherFirstname: "Ганаа",
        teacherLastname: "Уртнасан",
        teacherEmail: "Urtaa@gmail.com",
        teacherSchool: "23-р сургууль",
        teacherPlaceId: "7",
        loginName: "99666655",
      },
    };
  },
  updateProfile(data) {
    return axios.post(
      `${RESOURCE_NAME}/index.php?r=private/update-profile`,
      data,
      {
        auth: {
          username: store.state.username,
          password: store.state.password,
        },
      }
    );
  },

  //багцын хүсэлт үүсгэнэ
  // {
  //   "angi": 1,
  //   "bagts": 1
  // }
  // буцаах утга:
  // {
  //   "status": "success"
  // }
  requestBagts(data) {
    return axios.post(`${RESOURCE_NAME}/index.php?r=private/request`, data, {
      auth: {
        username: store.state.username,
        password: store.state.password,
      },
    });
  },

  // багцын хүсэлт илгээсэнг шалгана.
  // {
  //   "angi": 1,
  //   "bagts": 1
  // }
  //
  // {
  //   "isBought": false,
  //   "isOpened": false,
  //   "isRequested": false
  // }
  checkBagts(data) {
    return axios.post(
      `${RESOURCE_NAME}/index.php?r=private/check-bagts`,
      data,
      {
        auth: {
          username: store.state.username,
          password: store.state.password,
        },
      }
    );
  },

  // {
  //   "angi": 1,
  //   "bagts": 1
  // }
  openBagts(data) {
    return axios.post(`${RESOURCE_NAME}/index.php?r=private/open-bagts`, data, {
      auth: {
        username: store.state.username,
        password: store.state.password,
      },
    });
  },

  // {
  //   "angi": 1,
  //   "bagts": 1
  // }
  getLevels(data) {
    return axios.post(`${RESOURCE_NAME}/index.php?r=private/get-levels`, data, {
      auth: {
        username: store.state.username,
        password: store.state.password,
      },
    });
  },

  getQuestion(data) {
    /** sample data: qid : 1,2,3,4,5-iin ali neg ni baina.
     * {
          "angi": 1,
          "bagts": 1,
          "level": 1,
          "qid":5
        }
     */
    return axios.post(`${RESOURCE_NAME}/index.php?r=private/question`, data, {
      auth: {
        username: store.state.username,
        password: store.state.password,
      },
    });
  },
  checkQuestion(data) {
    /** sample data:
     * {
          "angi": 1,
          "bagts": 1,
          "qid": 2197,
          "aid": "D"
        }
     */
    return axios.post(`${RESOURCE_NAME}/index.php?r=private/check`, data, {
      auth: {
        username: store.state.username,
        password: store.state.password,
      },
    });
  },
  getAnswer(data) {
    /** sample data:
     * {
          "angi": 1,
          "bagts": 1,
          "level": 1,
          "qid":5
        }
     */
    return axios.post(`${RESOURCE_NAME}/index.php?r=private/answer`, data, {
      auth: {
        username: store.state.username,
        password: store.state.password,
      },
    });
  },
  getExpect(data) {
    /** sample data:
     * {
          "angi": 1,
          "bagts": 1,
          "level": 1,
          "qid":5
        }
     */
    return axios.post(`${RESOURCE_NAME}/index.php?r=private/explain`, data, {
      auth: {
        username: store.state.username,
        password: store.state.password,
      },
    });
  },

  endLevel(data) {
    /**
     * {
          "angi": 1,
          "bagts": 1,
          "level": 9,
          "score": 3
        }
     */
    return axios.post(
      `${RESOURCE_NAME}/index.php?r=private/lend`,
      data,
      {
        auth: {
          username: store.state.username,
          password: store.state.password,
        },
      }
    );
  },

  endSoril(data) {
    return axios.post(
      `${RESOURCE_NAME}/index.php?r=private/send`,
      data,
      {
        auth: {
          username: store.state.username,
          password: store.state.password,
        },
      }
    );
  },

  sorilList(data) {
    /**
     * 
     * {
          "angi": 1,
          "bagts": 1,
          "sorilNo": 1
        }
     * 
     */
    return axios.post(
      `${RESOURCE_NAME}/index.php?r=soril/list`,
      data,
      {
        auth: {
          username: store.state.username,
          password: store.state.password,
        },
      }
    );
  },

  sorilQuestion(data) {
    /**
     * {
          "angi": 1,
          "bagts": 1,
          "sorilNo": 1,
          "qid": 793
        }
     */
    return axios.post(
      `${RESOURCE_NAME}/index.php?r=soril/question`,
      data,
      {
        auth: {
          username: store.state.username,
          password: store.state.password,
        },
      }
    );
  },

  sorilCheck(data) {
    /**
     * 
     * {
          "angi": 1,
          "bagts": 1,
          "sorilNo": 1,
          "pairs": [ 
            {
              "qid": 793,
              "aid": "A"
            },
            {
              "qid": 332,
              "aid": "C"
            }
          ]
        }
     * 
     * 
     */
    return axios.post(
      `${RESOURCE_NAME}/index.php?r=soril/check`,
      data,
      {
        auth: {
          username: store.state.username,
          password: store.state.password,
        },
      }
    );
  }
};
